export default __webpack_public_path__ + "static/media/INTP-3.634bf10f.png";